import { resourceReducer, getResources } from 'redux-resource';
import { reset, httpStatusCodes } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const leases = resourceReducer('leases', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default leases;

export const getSubLeases = (state, page = 1) =>
  getResources(state, `subLeases${page}`);
export const getOutstandingLeases = (state, page = 1) =>
  getResources(state, `outstandingSubLeases`);
export const getLease = (state, leaseId) => getResources(state, [leaseId])[0];
export const getUserLeases = (state, userId) =>
  getResources(state, (resource) => resource.user_profile === userId);
export const getLeases = (state, page = 1) =>
  getResources(state, `leases${page}`);
export const getLeaseNotFound = (state, leaseId) =>
  state.meta[leaseId] && state.meta[leaseId].readStatusCode === 404;
